<template lang="pug">
  .input-container(:class="{ open }")
    label {{ title }}
    .select(@click.prevent="dropdown" ref="dropdown")
      .select-placeholder(v-if="!open") {{ optionValue }}
      .select-options(v-else)
        .options(v-for="option in options" @click.prevent="updateValue(option)" :selected="selected === option.toLowerCase()") {{ option }}
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'dropdown',
  props: {
    options: Array,
    title: String,
    selected: String,
  },
  data () {
    return {
      open: false,
      optionValue: this.options[0],
    }
  },
  beforeMount () {
    if (this.selected) {
      this.optionValue = this.options.find(val => {
        return val.toLowerCase() === this.selected
      })
    }
  },
  watch: {
    booking () {
      if (!this.booking) {
        this.optionValue = this.options[0]
      }
      return this.booking
    },
  },
  computed: {
    ...mapState('menu', ['booking']),
  },
  updated () {
    // this.updateValue(this.$route.query.form)
  },
  methods: {
    dropdown () {
      this.open = !this.open
    },
    updateValue (option) {
      this.optionValue = option
      this.$emit('update', option)
    },
  },
  components: {
  },
}
</script>

<style scoped lang="scss">
.input-container {
  position: relative;
  display: flex;
  justify-content: flex-end;
  height: 35px;
  z-index: 1;
  &.open {
    z-index: 3;
  }
}

label {
  position: absolute;
  width: 100%;
  font-size: 1.75rem;
  bottom: -7px;

  @media (max-width: 1150px) {
    font-size: 1.5rem;
    line-height: 1.3;
  }
}

.select {
  font-size: 1.5em;
  background: none;
  border: none;
  color: $cream;
  font-family: 'Martha Regular';
  background: url('../assets/images/dropdown-arrow.svg') 0 / 16px no-repeat;
  background-position: right 14px;
  width: auto;
  padding-right: 32px;
  text-transform: uppercase;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  z-index: 1;

  @media (max-width: 1150px) {
    padding-right: 25px;
    background: url('../assets/images/dropdown-arrow.svg') 0px / 12px no-repeat;
    background-position: right 19px;
    font-size: 1rem;
    height: 40px;
  }

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }
  .select-placeholder {
    font-size: $book-now-font-size;
    text-transform: capitalize;
    text-transform: uppercase;
    line-height: 1.75;

    @media (max-width: 1150px) {
      line-height: 2.75;
      font-size: 1.125rem;;
    }
  }
}

.dropdown-arrow {
  position: absolute;
  right: 0;
  bottom: 5px;
  width: 18px;
  z-index: 4;

  @media (max-width: 1150px) {
    width: 12px;
  }
  svg {
    width: 100%;
  }
}

.select-options {
  position: absolute;
  right: 0;
  top: 35px;
  background: $cream;
  color: $violent-sunset;
  z-index: 1;
  text-align: right;
  width: 100%;

  .options {
    padding: 10px 20px;
    font-size: 1.4rem;
    text-transform: uppercase;

    @media (max-width: 1150px) {
      font-size: 1.125rem;
    }

    &:hover {
      background: #9c9c9c1a;
    }
  }
}
</style>
